import * as yup from "yup";
import { IResponseAttachmentType } from "../../../../../api/services";

export const validationSchema = yup.object({
    file: yup
        .mixed()
        .nullable(true)
        .required('message.validation.required')
    ,
    type: yup
        .object()
        .nullable(true)
        .required("message.validation.required")
});

export interface IFormValues {
    file: File | null,
    type: IResponseAttachmentType | null
}
